import {
    HandlerWithResult,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { BatchGetProductsApiParameter } from "@insite/client-framework/Services/ProductService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import {
    OrderUploadRowError,
} from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import { batchGetProductsExtended } from "@thos/Services/ProductServiceExtended";


export interface BatchLoadProductsParameter extends BatchGetProductsApiParameter {
    firstRowHeading: boolean;
    checkInventory: boolean;
}

export interface BatchLoadProductsResult {
    apiParameter: BatchGetProductsApiParameter;
    apiResult: (ProductDto | null)[];
    products: ProductDto[];
    rowErrors: OrderUploadRowError[];
}

type HandlerType = HandlerWithResult<BatchLoadProductsParameter, BatchLoadProductsResult>;

export const InitializeResult: HandlerType = props => {
    props.result = {
        apiParameter: { extendedNames: [] },
        apiResult: [],
        products: [],
        rowErrors: [],
    };
};

export const RequestDataFromApiExtended: HandlerType = async props => {
    props.result.apiResult = await batchGetProductsExtended(props.result.apiParameter);
};
// TSCO-210 | Order Upload does not work with CPN customization
replaceInChain(chain, RequestDataFromApi, RequestDataFromApiExtended);